import RegistrationCodes from '../components/registration_codes/List.vue'
import RegistrationCodeModals from './../components/registration_codes/Modals.vue'
import { createApp } from 'vue';
import { createPinia } from 'pinia'

const pinia = createPinia();

if ( document.getElementById('registration_codes') ) {

  const app = createApp({
    components: { 'registration-codes': RegistrationCodes },
  });

  app.use(pinia)
  app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
  app.mount('#registration_codes');
}


if ( document.getElementById('registration-code-modals') ) {
    const app2 = createApp({
        components: {
            RegistrationCodeModals,
        },
    })

    app2.use(pinia)
    app2.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app2.mount('#registration-code-modals');
}
